"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applicationService = void 0;
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var applicationService = exports.applicationService = {
  // Application methods
  createApplication: createApplication,
  fetchApplications: fetchApplications,
  updateApplication: updateApplication,
  deleteApplication: deleteApplication,
  fetchApplicationsByLot: fetchApplicationsByLot,
  fetchActiveApplications: fetchActiveApplications,
  fetchFilteredApplications: fetchFilteredApplications,
  fetchApplicationsByDateRange: fetchApplicationsByDateRange,
  // Prescription methods
  createPrescription: createPrescription,
  fetchPrescriptions: fetchPrescriptions,
  fetchPrescriptionsByDateRange: fetchPrescriptionsByDateRange,
  updatePrescription: updatePrescription,
  deletePrescription: deletePrescription,
  fetchPrescriptionsDropdown: fetchPrescriptionsDropdown,
  fetchPrescriptionById: fetchPrescriptionById,
  fetchProductsDropdown: fetchProductsDropdown,
  // Product methods
  createProduct: createProduct,
  fetchProducts: fetchProducts,
  fetchProductsByDateRange: fetchProductsByDateRange,
  updateProduct: updateProduct,
  deleteProduct: deleteProduct,
  importProductsCSV: importProductsCSV,
  // Equipment methods
  createEquipment: createEquipment,
  fetchEquipments: fetchEquipments,
  fetchEquipmentsByDateRange: fetchEquipmentsByDateRange,
  updateEquipment: updateEquipment,
  deleteEquipment: deleteEquipment,
  fetchEquipmentsDropdown: fetchEquipmentsDropdown,
  // Structure methods
  createLot: createLot,
  fetchLots: fetchLots,
  updateLot: updateLot,
  deleteLot: deleteLot,
  createSector: createSector,
  updateSector: updateSector,
  deleteSector: deleteSector,
  fetchSectorsDropdown: fetchSectorsDropdown,
  fetchFarmCounts: fetchFarmCounts
};

// Application functions
function createApplication(data) {
  var path = "/application/application";
  return _http.default.post(path, data);
}
function fetchApplications(params) {
  var path = "/application/application";
  return _http.default.get(path, {
    params: params
  });
}
function updateApplication(id, data) {
  var path = "/application/application/".concat(id);
  return _http.default.put(path, data);
}
function deleteApplication(id, farmId) {
  var path = "/application/application/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function fetchApplicationsByLot(farmId, lotId) {
  var path = "/application/application/lot/".concat(farmId, "/").concat(lotId);
  return _http.default.get(path);
}
function fetchActiveApplications(farmId) {
  var path = "/application/application/active/".concat(farmId);
  return _http.default.get(path);
}

// Prescription functions
function createPrescription(data) {
  var path = "/application/prescription";
  return _http.default.post(path, data);
}
function fetchPrescriptions(params) {
  var path = "/application/prescription";
  return _http.default.get(path, {
    params: params
  });
}
function fetchPrescriptionsByDateRange(farmId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = "/application/prescription/filter/".concat(farmId);
  return _http.default.get(path, {
    params: params
  });
}
function updatePrescription(id, data) {
  var path = "/application/prescription/".concat(id);
  return _http.default.put(path, data);
}
function deletePrescription(id, farmId) {
  var path = "/application/prescription/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function fetchPrescriptionsDropdown(farmId) {
  var path = "/application/prescription/dropdown/".concat(farmId);
  return _http.default.get(path);
}
function fetchPrescriptionById(id, farmId) {
  var path = "/application/prescription/".concat(id);
  return _http.default.get(path, {
    params: {
      farmId: farmId
    }
  });
}
function fetchProductsDropdown(farmId) {
  var path = "/application/product/dropdown/".concat(farmId);
  return _http.default.get(path);
}

// Product functions
function createProduct(data) {
  var path = "/application/product";
  return _http.default.post(path, data);
}
function fetchProducts(params) {
  var path = "/application/product";
  return _http.default.get(path, {
    params: params
  });
}
function fetchProductsByDateRange(farmId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = "/application/product/filter/".concat(farmId);
  return _http.default.get(path, {
    params: params
  });
}
function updateProduct(id, data) {
  var path = "/application/product/".concat(id);
  return _http.default.put(path, data);
}
function deleteProduct(id, farmId) {
  var path = "/application/product/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function importProductsCSV(farmId, file) {
  var path = "/application/product/import-csv/".concat(farmId);
  var formData = new FormData();
  formData.append('file', file);
  return _http.default.post(path, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// Structure functions
function createLot(data) {
  var path = "/application/lot";
  return _http.default.post(path, data);
}
function fetchLots(params) {
  var path = "/application/lot";
  return _http.default.get(path, {
    params: params
  });
}
function updateLot(id, data) {
  var path = "/application/lot/".concat(id);
  return _http.default.put(path, data);
}
function deleteLot(id, farmId) {
  var path = "/application/lot/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function createSector(data) {
  var path = "/application/sector";
  return _http.default.post(path, data);
}
function updateSector(id, data) {
  var path = "/application/sector/".concat(id);
  return _http.default.put(path, data);
}
function deleteSector(id, farmId) {
  var path = "/application/sector/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function fetchSectorsDropdown(farmId) {
  var path = "/application/sector/dropdown/".concat(farmId);
  return _http.default.get(path);
}
function fetchFarmCounts(farmId) {
  var path = "/application/lot/farm/".concat(farmId, "/counts");
  return _http.default.get(path);
}
function fetchFilteredApplications(farmId, year) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = "/application/application/filter/".concat(farmId, "/").concat(year);
  return _http.default.get(path, {
    params: params
  });
}
function fetchApplicationsByDateRange(farmId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = "/application/application/filter/".concat(farmId);
  return _http.default.get(path, {
    params: params
  });
}

// Equipment functions
function createEquipment(data) {
  var path = "/application/equipment";
  return _http.default.post(path, data);
}
function fetchEquipments(params) {
  var path = "/application/equipment";
  return _http.default.get(path, {
    params: params
  });
}
function fetchEquipmentsByDateRange(farmId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = "/application/equipment/filter/".concat(farmId);
  return _http.default.get(path, {
    params: params
  });
}
function updateEquipment(id, data) {
  var path = "/application/equipment/".concat(id);
  return _http.default.put(path, data);
}
function deleteEquipment(id, farmId) {
  var path = "/application/equipment/".concat(id);
  return _http.default.delete(path, {
    params: {
      farmId: farmId
    }
  });
}
function fetchEquipmentsDropdown(farmId) {
  var path = "/application/equipment/dropdown/".concat(farmId);
  return _http.default.get(path);
}